<div class="modal-header">
  <h3>Material Einheit {{this.form.value.id ? 'bearbeiten' : 'erstellen'}}</h3>
</div>
<form class="form-horizontal" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="form-group">
      <div class="col-sm-2 control-label">
        <label for="unit">Bezeichnung</label>
      </div>
      <div class="col-sm-8">
        <input id="unit" type="text" class="form-control" formControlName="unit" autofocus>
      </div>
    </div>

    @if (errorCode) {
      <div class="row">
        <div class="col-sm-12 red_alert" style="clear: both">
          @switch (errorCode) {
            @case (404) {
              <h3>Die Einheit wurde nicht gefunden</h3>
            }
            @case (409) {
              <h3>Diese Einheit existiert bereits</h3>
            }
            @default {
              <h3>Unbekannter Fehler beim &Uuml;bertragen des Formulars</h3>
            }
          }
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger pull-left" (click)="dismiss()">
      Abbrechen
    </button>

    <button type="submit" class="btn btn-success pull-right" [disabled]="!this.form.valid">
      @if (this.form.value.id) {
        Speichern
      }
      @if (!this.form.value.id) {
        Hinzuf&uuml;gen
      }
    </button>
  </div>
</form>
